import React from 'react'

import { Form, Col } from '_zari/core'

const TipoDocumentoFormGroup = ({ iSerieValue, iNumeroValue }) => {
  return (
    <Form.Group>
      <Form.Label text='DOCUMENTO' md={4} />
      <Col md={8}>
        <Form.InputText
          value={`${iSerieValue} - ${iNumeroValue}`}
          id='input-serieDocumento'
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
